// Images content starts
$(document).ready(function () {
  $('.ve_multi_slide-text').each(function () {
    var $container = $(this);
    var $body = $container.find('.ve_multi_slide-body');
    var $toggle = $container.find('.ve_multi_slide-toggle');
    var fullHtml = $body.html().trim();
    var maxLength = 430;
    var textLength = $('<div>').html(fullHtml).text().length;
    if (textLength <= maxLength) return;

    var truncatedHtml = truncateHtml(fullHtml, maxLength);

    $body.html(truncatedHtml);
    $toggle.show().text('See More');

    $toggle.on('click', function () {
      if ($toggle.hasClass('is-open')) {
        $body.html(truncatedHtml);
        $toggle.text('See More').removeClass('is-open');
      } else {
        $body.html(fullHtml);
        $toggle.text('See Less').addClass('is-open');
      }
    });
  });

  function truncateHtml(html, limit) {
    var source = document.createElement('div');
    source.innerHTML = html;

    var output = document.createElement('div');
    var count = 0;

    function walk(node, parent) {
      if (count >= limit) return;

      if (node.nodeType === Node.TEXT_NODE) {
        var remaining = limit - count;
        var text = node.nodeValue.slice(0, remaining);
        count += text.length;
        parent.appendChild(document.createTextNode(text));
      } 
      else if (node.nodeType === Node.ELEMENT_NODE) {
        var clone = node.cloneNode(false);
        parent.appendChild(clone);
        Array.from(node.childNodes).forEach(function (child) {
          walk(child, clone);
        });
      }
    }

    Array.from(source.childNodes).forEach(function (child) {
      walk(child, output);
    });

    return output.innerHTML + '...';
  }
});
// Images content ends



// Countdown starts
// document.addEventListener('DOMContentLoaded', function() {
//   function getNextFridayDeadline() {
//     const now = new Date();
//     const currentDay = now.getDay();
//     const daysUntilFriday = currentDay <= 5 ? 5 - currentDay : 6;
    
//     const nextFriday = new Date(now);
//     nextFriday.setDate(now.getDate() + daysUntilFriday);
//     nextFriday.setHours(0, 0, 0, 0);
    
//     return nextFriday;
//   }

//   function initializeCountdown() {
//     const countdownSection = document.querySelector('[data-friday-deadline]');
//     if (!countdownSection) return;
    
//     const daysElement = countdownSection.querySelector('.days');
//     const hoursElement = countdownSection.querySelector('.hours');
//     const minutesElement = countdownSection.querySelector('.minutes');
//     const secondsElement = countdownSection.querySelector('.seconds');
    
//     const deadline = getNextFridayDeadline();
    
//     const countdownInterval = setInterval(function() {
//       const now = new Date().getTime();
//       const distance = deadline.getTime() - now;
      
//       if (distance < 0) {
//         clearInterval(countdownInterval);
//         countdownSection.style.display = 'none';
//         return;
//       }
      
//       const days = Math.floor(distance / (1000 * 60 * 60 * 24));
//       const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//       const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//       const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
//       if (daysElement) daysElement.textContent = String(days).padStart(2, '0');
//       if (hoursElement) hoursElement.textContent = String(hours).padStart(2, '0');
//       if (minutesElement) minutesElement.textContent = String(minutes).padStart(2, '0');
//       if (secondsElement) secondsElement.textContent = String(seconds).padStart(2, '0');
//     }, 1000);
    
//     const now = new Date().getTime();
//     const distance = deadline.getTime() - now;
//     if (distance < 0) {
//       countdownSection.style.display = 'none';
//       clearInterval(countdownInterval);
//     }
//   }

//   initializeCountdown();
// });
// Countdown ends
